import dayjs from 'dayjs'

/**
 * Mantine v8 date components emit the picked day as a `YYYY-MM-DD` string.
 * `new Date('YYYY-MM-DD')` parses as midnight UTC — which is the *previous*
 * calendar day in US timezones — so a date round-tripped through
 * `.toISOString()` is stored one day early. Build the `Date` from local
 * components instead (same idiom as AvailabilityModal).
 */
export function parseDateInputValue(value: string | null | undefined): Date | null {
  if (!value) return null
  const [year, month, day] = value.split('-').map(Number)
  if (!year || !month || !day) return null
  return new Date(year, month - 1, day)
}

/**
 * PD-1901 — the month a date picker opens on: its value's, else today, kept
 * within `minDate`/`maxDate` so the opening month always has a pickable day.
 */
export function pickerOpeningDate(
  value: string | Date | null | undefined,
  minDate?: string | Date,
  maxDate?: string | Date,
): string {
  if (value) return dayjs(value).format('YYYY-MM-DD')
  const today = dayjs()
  if (minDate && today.isBefore(minDate, 'day')) return dayjs(minDate).format('YYYY-MM-DD')
  if (maxDate && today.isAfter(maxDate, 'day')) return dayjs(maxDate).format('YYYY-MM-DD')
  return today.format('YYYY-MM-DD')
}
